/**
 * Task NN — 投诉与建议 / Feedback: shops send complaints, suggestions and bug reports to the Senvia team; the platform
 * admin answers in Platform admin → 投诉与建议. Shared by the API and the web app.
 */
export const FEEDBACK_TYPES = ["complaint", "suggestion", "bug"] as const;
export type FeedbackType = (typeof FEEDBACK_TYPES)[number];
/** 收银, 预约, 会员/配套, 工资, 官网/网店, App, 账单/付款, 其他 */
export const FEEDBACK_CATEGORIES = ["pos", "booking", "membership", "payroll", "website", "app", "billing", "other"] as const;
export type FeedbackCategory = (typeof FEEDBACK_CATEGORIES)[number];
/** 已提交 / 处理中 / 已回复 / 已解决 / 已关闭 */
export const FEEDBACK_STATUSES = ["submitted", "in_progress", "replied", "resolved", "closed"] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];
/** 低 / 中 / 高 / 紧急 */
export const FEEDBACK_PRIORITIES = ["low", "normal", "high", "urgent"] as const;
export type FeedbackPriority = (typeof FEEDBACK_PRIORITIES)[number];

/** at most this many images per ticket / per message */
export const FEEDBACK_MAX_IMAGES = 5;
/** a resolved / closed ticket may be reopened by the shop for this many days */
export const FEEDBACK_REOPEN_DAYS = 14;
export const FEEDBACK_TITLE_MAX = 150;
export const FEEDBACK_BODY_MAX = 8000;

export const isFeedbackType = (x: unknown): x is FeedbackType => typeof x === "string" && (FEEDBACK_TYPES as readonly string[]).includes(x);
export const isFeedbackCategory = (x: unknown): x is FeedbackCategory => typeof x === "string" && (FEEDBACK_CATEGORIES as readonly string[]).includes(x);
export const isFeedbackStatus = (x: unknown): x is FeedbackStatus => typeof x === "string" && (FEEDBACK_STATUSES as readonly string[]).includes(x);
export const isOpenFeedback = (s: FeedbackStatus) => s !== "resolved" && s !== "closed";

/** may the shop reopen it? (resolved / closed less than 14 days ago) */
export function canReopenFeedback(t: { status: FeedbackStatus; resolvedAt?: string | Date | null; closedAt?: string | Date | null }, now = new Date()): boolean {
  if (isOpenFeedback(t.status)) return false;
  const at = t.status === "closed" ? (t.closedAt ?? t.resolvedAt) : (t.resolvedAt ?? t.closedAt);
  if (!at) return false;
  return now.getTime() - new Date(at).getTime() <= FEEDBACK_REOPEN_DAYS * 86_400_000;
}

/** "#000123" */
export const feedbackRef = (no: number | string) => "#" + String(no).padStart(6, "0");
